export default {
  lastDocument: ({ lastDocument }) => lastDocument
};
